import store from '@/store'

/**
 * 按钮权限判断（数据来自登录时 getRouters 写入的 store）
 * @param {string|number} id 按钮 id
 * @returns {boolean}
 */
export function checkButtonPermission(id) {
	const targetId = String(id)
	const permissions = ((store.getters && store.getters.permissions) || []).map(item => String(item))
	if (permissions.includes('*:*:*') || permissions.includes(targetId)) {
		return true
	}
	const buttonIds = (store.getters['menu/buttonPermissionIds'] || []).map(item => String(item))
	return buttonIds.includes(targetId)
}

export default checkButtonPermission
